import { render, staticRenderFns } from "./OverseaStudentFormPage.vue?vue&type=template&id=fac5c26c&scoped=true"
import script from "./OverseaStudentFormPage.vue?vue&type=script&lang=js"
export * from "./OverseaStudentFormPage.vue?vue&type=script&lang=js"
import style0 from "./OverseaStudentFormPage.vue?vue&type=style&index=0&id=fac5c26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac5c26c",
  null
  
)

export default component.exports